import { render, staticRenderFns } from "./HotspotList.vue?vue&type=template&id=5b21c87e"
import script from "./HotspotList.vue?vue&type=script&lang=js"
export * from "./HotspotList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports